// Collapsed technical details: server codes and detail text for support, out of the main flow.
import type { Diagnostic } from '../lib/userCopy.ts';

export function Diagnostics({ diagnostic, label = 'Technical details' }: { diagnostic: Diagnostic | null | undefined; label?: string }) {
  if (!diagnostic || (!diagnostic.code && !diagnostic.detail && !diagnostic.requestId)) return null;
  return (
    <details className="diagnostics">
      <summary>{label}</summary>
      <dl>
        {diagnostic.code ? (
          <>
            <dt>Code</dt>
            <dd className="mono">{diagnostic.code}</dd>
          </>
        ) : null}
        {diagnostic.detail ? (
          <>
            <dt>Detail</dt>
            <dd>{diagnostic.detail}</dd>
          </>
        ) : null}
        {diagnostic.requestId ? (
          <>
            <dt>Reference</dt>
            <dd className="mono">{diagnostic.requestId}</dd>
          </>
        ) : null}
      </dl>
    </details>
  );
}
